import {connect} from 'react-redux';
import {toggleTheme} from '../../../../modules/Theme/actions';

import BaseDoughnutLegend from './BaseDoughnutLegend';
import formatVolumeValue from './volume-doughnut-legend-formatter';
import formatMonetaryValue from './monetary-doughnut-legend-formatter';
import formatDurationValue from './duration-doughnut-legend-formatter';
import formatSmsValue from './sms-doughnut-legend-formatter';

const formatters = {
  VOLUME: formatVolumeValue,
  DURATION: formatDurationValue,
  MONETARY: formatMonetaryValue,
  NUMBER: formatSmsValue,
};

function getDoughnutLegend(formatterType) {
  const formatValue = formatters[formatterType];

  function mergeProps(stateProps, dispatchProps, ownProps) {
    const formattedValue = ownProps.max
      ? formatValue(ownProps.current, ownProps.max)
      : {};
    const mergedProps = {
      ...formattedValue,
      color: ownProps.color,
      isActive: ownProps.isActive,
      label: ownProps.label,
      hideMaxValue: ownProps.hideMaxValue,
    };
    return mergedProps;
  }

  const mapDispatchToProps = {
    toggleTheme,
  };

  return connect(null, mapDispatchToProps, mergeProps)(BaseDoughnutLegend);
}

const VolumeDoughnutLegend = getDoughnutLegend('VOLUME');
const DurationDoughnutLegend = getDoughnutLegend('DURATION');
const MonetaryDoughnutLegend = getDoughnutLegend('MONETARY');
const SmsDoughnutLegend = getDoughnutLegend('NUMBER');

export {
  VolumeDoughnutLegend,
  DurationDoughnutLegend,
  MonetaryDoughnutLegend,
  SmsDoughnutLegend,
  BaseDoughnutLegend,
};

export default BaseDoughnutLegend;
